// 菜单
export default [{ // 租户菜单
  path: '/menuManager',
  name: 'menuManager',
  component: resolve => require(['@/views/menu/menuManager.vue'], resolve),
  meta: {
    group: "/menuManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 菜单管理
  path: '/opsMenu',
  name: 'opsMenu',
  component: resolve => require(['@/views/menu/opsMenu.vue'], resolve),
  meta: {
    group: "/opsMenu",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/menu/menu.js